import React, { CSSProperties, FC } from 'react';
import { i18nTranslationKey, localizedInterpolation } from 'state/i18n';
import { LabelValuesJSX } from 'view/shared/components/label-value-card';
import BiTooltip from 'view/shared/components/bi-tooltip/bi-tooltip';
import { getIcon } from 'view/shared/utils/icon-helper';
import { IconSmallSize } from 'utilities/constants';

interface Props {
	show?: boolean;
	connectedBleTagMac?: string | null;
	translationKey: i18nTranslationKey;
	wrapperClassName?: string;
	wrapperStyle?: CSSProperties;
	iconSize?: number;
}

const BleTagSourceIndicator: FC<Props> = ({
	show,
	connectedBleTagMac,
	translationKey,
	wrapperClassName,
	wrapperStyle,
	iconSize,
}) => {
	if (!show) {
		return null;
	}

	const mac = connectedBleTagMac ?? '';

	return (
		<span
			className={`display-inline-block ${wrapperClassName ?? ''}`}
			style={{ verticalAlign: 'middle', ...wrapperStyle }}
		>
			<BiTooltip overlay={localizedInterpolation(translationKey, { mac })}>
				{getIcon('info-circle', iconSize)}
			</BiTooltip>
		</span>
	);
};

export default BleTagSourceIndicator;

// Wraps a label-value-card value with a BleTagSourceIndicator, used wherever a field's value can come
// from a connected BLE tag. Only wraps in JSX when `show` is true - addTranslationLabelValueMapToList's
// editable branch casts the value to a plain string/number for EditableValue, which JSX would break.
export const withBleTagSourceIndicator = (
	label: LabelValuesJSX,
	show: boolean | undefined,
	connectedBleTagMac: string | null | undefined,
	translationKey: i18nTranslationKey
): LabelValuesJSX =>
	show ? (
		<span className="flex-direction-row flex-center-column flex-space-between-row">
			{label}
			<BleTagSourceIndicator show connectedBleTagMac={connectedBleTagMac} translationKey={translationKey} iconSize={IconSmallSize} />
		</span>
	) : (
		label
	);
